import { useErrorStore } from '@common/stores/error-store';
import { Button } from '@konova/ui/button';
import { Modal, ModalProps } from '@konova/ui/modal';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

export type ErrorDialogProps = Omit<ModalProps, 'label'>;

export const ErrorDialog: FC<ErrorDialogProps> = props => {
  const errorStore = useErrorStore();
  const [t] = useTranslation();

  return (
    <Modal
      {...props}
      open={errorStore.open}
      onClose={() => errorStore.close()}
      footer={
        <Button variant={'text'} onClick={() => errorStore.close()}>
          {t('common.close')}
        </Button>
      }
      title={errorStore.title}
      label={errorStore.title ?? t('common.unknown-error')}
    >
      {errorStore.description}
    </Modal>
  );
};
